import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap/lib'

class FooterData extends Component {

  render() {
    return (
      <div className="FooterData">
        <Grid>
          <Row>
            <Col className="" md={12}>
              info@constructeursregister.nl | 088-353 12 99 | Louis Braillelaan 80 | 2719 EK Zoetermeer
            </Col>
          </Row>
        </Grid>
      </div>

    );
  }
}

export default FooterData;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/FooterData.js